import axios, { AxiosResponse } from 'axios'
import Api from './Api'
import { Vm } from '@/main';
import { Store } from './Store';

class FaqRepository {



    public async getAll(): Promise<IFaq[]> {
        if (navigator.onLine) {
            try {
                var res = await Api.getData("Faq/GetAll");

                if (res.status == 200)
                    return res.data as IFaq[];

            } catch {
                return [];
            }
        } else {
            return [];
        }

        return [] as IFaq[];
    }

    
}

export interface IFaq {
    id: string;
    question: string;
    answer: number;
    timestamp: string;
    displayOrder : number;
}

export const FaqRepo = new FaqRepository();